module.exports = __webpack_public_path__ + "a46369e8f24de1c76f119724f2063d2c.png";